import { Controller } from "stimulus";
import Rails from "rails-ujs";


export default class extends Controller {
  static targets = ["input", "inputWrapper"];
  
  connect() {
  }

  
  toggleInput(e) {
    e.preventDefault();
    this.inputWrapperTarget.classList.toggle("hidden");
    this.inputWrapperTarget.querySelector("form").toggle("hidden");
  }

  checkAndApply() {
    this.check(); 
  }

  check() {

    fetch("/shop/cart/check_discount_code", {
      method: "post",
      credentials: "same-origin",
      headers: {
        'Accept': 'text/vnd.turbo-stream.html',
        "Content-Type": "application/json",
        "X-CSRF-Token": Rails.csrfToken(),
      },
      body: JSON.stringify({ code: this.inputTarget.value }),
    }).then((response) => {   
        console.log("res:", response);
        if (response.ok) {
          console.log("found valid and unused discount code")
        } else {
          console.log("invalid discount code")
        }
    });
  }

}
